import { render, staticRenderFns } from "./transferDetail.vue?vue&type=template&id=5fc3f1b5&scoped=true"
import script from "./transferDetail.vue?vue&type=script&lang=js"
export * from "./transferDetail.vue?vue&type=script&lang=js"
import style0 from "./transferDetail.vue?vue&type=style&index=0&id=5fc3f1b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc3f1b5",
  null
  
)

export default component.exports